import WebHttpService from './WebHttpService';


class VersionService {
    constructor(http) {
        this.http = http;        
    }

    async getBackendVersion() {
        try {
            return await this.http.get('/api/version')
        } 
        catch(error) {
            console.log(error);
        }
    }
}

export default new VersionService(WebHttpService)
